// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import {
  usePendingIncomingPayment,
  getCountry,
} from '@tectonics/prs/incoming-payment';
import { formatUberPixExpirationDatetime } from '@tectonics/prs/voucher';
import { getExpirationOrDueDatetime } from '@tectonics/prs/incoming-payment/get-expiration-or-due-datetime';

export function PixTicketExpiration(): Node {
  const expirationDatetime = ExpirationDatetime();

  if (!expirationDatetime) {
    return (
      <Root>
        <Term></Term>
        <Definition></Definition>
      </Root>
    );
  }

  return (
    <Root>
      <Term>Pague até</Term>
      <Definition>{expirationDatetime}</Definition>
    </Root>
  );}

function ExpirationDatetime(): Node | null {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  const dateTobeFormatted = getExpirationOrDueDatetime(incomingPayment);
  const formattedDateToBeReturned : string | null = formatUberPixExpirationDatetime(dateTobeFormatted);

  switch (country) {
    case 'br':
      return formattedDateToBeReturned;

    default:
      throw new Error(`Voucher Ticket Due Date Title - Not implemented for country "${country}" yet`);
  }
}

const Root = styled.dl`
  text-align: center;
  padding: 1.2em;
`;

const Term = styled.dt`
  font-family: ${props => props.theme.fontFamily.sansSerif};
  font-size: 0.9em;
`;

const Definition = styled.dd`
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.3em;
  font-weight: bold;
`;
